// extracted by mini-css-extract-plugin
export var centerText = "_4o-8";
export var container = "_4o-0";
export var doughnutContainer = "_4o-7";
export var legend = "_4o-a";
export var legendItemColorDisplay = "_4o-b";
export var legendItemLabel = "_4o-d";
export var legendItemValue = "_4o-c";
export var lg = "_4o-5";
export var maxWidth = "_4o-9";
export var md = "_4o-4";
export var responsive = "_4o-6";
export var sm = "_4o-3";
export var xs = "_4o-2";
export var xxs = "_4o-1";